export const NEXCALIBER_ADDRESS = "14800 Quorum Dr # 540, Dallas TX 75254 United States";
export const NEXCALIBER_CONTACT = "1-800-741-0185";
export const NEXCALIBER_MAIL = "info@nexcaliber.com";
export const NEXCALIBER_MAIL_TWO = "qpa-idr@nexcaliber.com";

export const BBI_ADDRESS = "Brookshire Brothers, Inc. P.O. Box 1688, Lufkin, Texas. 75904";
export const BBI_CONTACT = "+1 936-634-8155";

export const NEXCALIBER_SUPPORT_MEMBERS = {
	jenifer_robertson: {
		name: "Jennifer Robertson",
		contact: "(936) 634-8155 ext 4212",
		designation: "Human Resources"
	},
	beezly_limited_indemnity: {
		name: "Beazley Limited Indemnity",
		contact: "1-800-508-9238",
		designation: "Call for ID cards or claims assistance"
	},
	beca_boland: {
		name: "Becca Boland",
		contact: "(936) 525-0145",
		designation: "For Portal related Queries"
	},
	medmutual: {
		name: "MedMutual",
		contact: "1-855-521-9345",
		designation: "Call for claims assistance"
	},
	nexcaliber: {
		name: "Nexcaliber",
		contact: "1-800-741-0185",
		designation: "Any questions regarding claims or existing coverage"
	},
	benefits_call_center: {
		name: "Benefits Call Center",
		contact: "833-356-0852",
		designation: "Monday through Friday 8:00am to 6:00pm CST"
	}
};

export const NEXCALIBER_DETAILS = {
	NEXCALIBER_ADDRESS,
	NEXCALIBER_CONTACT,
	NEXCALIBER_MAIL,
	NEXCALIBER_MAIL_TWO
};

export const BROOKSHIRE_BROTHERS_DETAILS = {
	BBI_ADDRESS,
	BBI_CONTACT
};
